import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";
import { useTranslations } from "use-intl";

import { Button } from "@/components/Button";

interface OTPPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (otp: string) => void;
  error?: string;
}

export const OTPPopup = ({
  isOpen,
  onClose,
  onSubmit,
  error,
}: OTPPopupProps) => {
  const t = useTranslations();
  const [otp, setOtp] = useState("");

  const handleSubmit = () => {
    onSubmit(otp);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      sx={{
        ".MuiPaper-root": {
          borderRadius: "var(--radius-2xl)",
          padding: "calc(var(--spacing)*2)",
        },
      }}
    >
      <DialogTitle>{t("payment.otp.title")}</DialogTitle>
      <DialogContent>
        <div className="flex flex-col gap-4 pt-4">
          <TextField
            variant="outlined"
            fullWidth
            label={t("payment.otp.inputLabel")}
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: { inputMode: "numeric", pattern: "d*" },
            }}
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder={t("payment.otp.inputPlaceholder")}
            error={!!error}
            helperText={error}
          />

          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            disabled={!otp}
          >
            {t("payment.otp.submitLabel")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
